export function slider(root = document) {
    if (typeof $.fn.slider !== 'function') {
        return false;
    }

    const $root = root?.jquery ? root : $(root);
    const $sliders = $root.is('.quiz-slider') ? $root : $root.find('.quiz-slider');

    /**
     * Slider
     */
    $sliders.each(function () {
        const $slider = $(this);
        if ($slider.hasClass('ui-slider')) {
            return;
        }

        const initialValue = parseInt($slider.data('value')) || 0;

        // Initialize slider
        $slider.slider({
            min: 0,
            max: 100,
            value: initialValue,
            slide: function (event, ui) {
                updateSlider($slider, ui.value);
            },
            create: function () {
                updateSlider($slider, initialValue);
            }
        });
    });

    return $sliders.length > 0;

    function updateSlider($slider, value) {
        $slider.closest('.quiz-slider-wrapper').find('.quiz-slider-value').attr('data-value', value);
        $slider.closest('.quiz-slider-wrapper').find('.quiz-slider-value').text(value + '%');
        $slider.css('--quiz-slider-fill-width', value + '%');
    }
}
